import { render, staticRenderFns } from "./EventSchedule.vue?vue&type=template&id=0060b2c1&"
import script from "./EventSchedule.vue?vue&type=script&lang=js&"
export * from "./EventSchedule.vue?vue&type=script&lang=js&"
import style0 from "./EventSchedule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports